module.exports = __webpack_public_path__ + "img/bb4becc690ddb7cfc6408bdb932efb5c.png";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/images/background.png
// module id = 82
// module chunks = 0